module.exports = __webpack_public_path__ + "img/img3-mob.1deaa739.png";